import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import Privacy from './pages/Privacy.tsx';
import Products from './pages/Products.tsx';
import Product2 from './pages/Product2.tsx';
import Product3 from './pages/Product3.tsx';
import Product4 from './pages/Product4.tsx';
import Product5 from './pages/Product5.tsx';
import Credits from './pages/Credits.tsx';
import Migration from './pages/Migration.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/produtos" element={<Products />} />
        <Route path="/produtos/produto-2" element={<Product2 />} />
        <Route path="/produtos/produto-3" element={<Product3 />} />
        <Route path="/produtos/produto-4" element={<Product4 />} />
        <Route path="/produtos/produto-5" element={<Product5 />} />
        <Route path="/creditos" element={<Credits />} />
        <Route path="/migracao" element={<Migration />} />
        <Route path="/consultoria" element={<Product5 />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
